exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".employee-list[data-v-0ec0f8da]{cursor:pointer}", ""]);

// exports
